export default "dist/wasmCluster.wasm";